import React from 'react';
import { LayoutDashboardIcon, ListTodoIcon, MoreHorizontalIcon, SparklesIcon, UsersIcon } from 'lucide-react';
import { View } from '../types/view';
interface BottomNavProps {
  currentView: View;
  onNavigate: (view: View) => void;
  onOpenMore: () => void;
  isMoreOpen: boolean;
}
interface Tab {
  id: View;
  label: string;
  icon: typeof LayoutDashboardIcon;
  /** Detail views that should keep this tab highlighted. */
  alsoActiveFor?: View[];
}
const tabs: Tab[] = [{
  id: 'dashboard',
  label: 'Overblik',
  icon: LayoutDashboardIcon
}, {
  id: 'tasks',
  label: 'Opgaver',
  icon: ListTodoIcon,
  alsoActiveFor: ['task-detail', 'add-task-page', 'manage-tasks-page']
}, {
  id: 'customers',
  label: 'Kunder',
  icon: UsersIcon,
  alsoActiveFor: ['customer-detail']
}, {
  id: 'mester-ai',
  label: 'Mester-AI',
  icon: SparklesIcon
}];

/**
 * Mobile primary navigation. Keeps the four most-used destinations one tap
 * away so the phone experience isn't a single long scroll through a menu.
 */
export function BottomNav({
  currentView,
  onNavigate,
  onOpenMore,
  isMoreOpen
}: BottomNavProps) {
  return <nav aria-label="Primær navigation" className="fixed bottom-0 left-0 right-0 z-40 border-t border-stone-200 bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur lg:hidden" data-id="element-197" data-mp="d0xs7g4y9x2h">
      <ul className="flex items-stretch" data-id="element-198" data-mp="411014jcqg2o">
        {tabs.map(tab => {
        const Icon = tab.icon;
        const isActive = !isMoreOpen && (currentView === tab.id || (tab.alsoActiveFor?.includes(currentView) ?? false));
        return <li key={tab.id} className="flex-1" data-id="element-199" data-mp="hy6cbm9nsb6d">
              <button onClick={() => onNavigate(tab.id)} aria-current={isActive ? 'page' : undefined} className={`flex w-full flex-col items-center gap-1 px-1 py-2.5 transition-colors ${isActive ? 'text-brand-700' : 'text-stone-400'}`} data-id="element-200" data-mp="mx996jfhjb39">
                <Icon className={`h-[22px] w-[22px] ${isActive ? 'text-brand-600' : 'text-stone-400'}`} data-id="element-201" data-mp="1p8r3geemhq2o" />
                <span className="text-[10px] font-semibold leading-none" data-id="element-202" data-mp="1fb4m7l9upmfj">
                  {tab.label}
                </span>
              </button>
            </li>;
      })}

        <li className="flex-1" data-id="element-203" data-mp="16bq1z3ka283h">
          <button onClick={onOpenMore} aria-expanded={isMoreOpen} className={`flex w-full flex-col items-center gap-1 px-1 py-2.5 transition-colors ${isMoreOpen ? 'text-brand-700' : 'text-stone-400'}`} data-id="element-204" data-mp="16cspd1ie5sen">
            <MoreHorizontalIcon className={`h-[22px] w-[22px] ${isMoreOpen ? 'text-brand-600' : 'text-stone-400'}`} data-id="element-205" data-mp="rnd0xs6c1z24" />
            <span className="text-[10px] font-semibold leading-none" data-id="element-206" data-mp="ilvpwo7s8nka">Mere</span>
          </button>
        </li>
      </ul>
    </nav>;
}